<div class="row">
    <div class="col-12">
        <h5 class="labelText mt-2">My Stubs</h5>
        <h6 class="labelText mt-2">View and download the pay slips</h6>
        <div class="row mb-2">
            <div class="col-4 pl-0">
                <label for="year" class="mb-1">Year</label><br />
                <p-dropdown  class='w-100' appendTo="body" [options]="getYears" [autoDisplayFirst]="true" placeholder="Year"
                    optionLabel="name" optionValue="code"  (onChange)="onChangeDuration($event,'year')">
                </p-dropdown>
            </div>
            <div class="col-4 pl-0">
                <label for="month" class="mb-1">Month</label><br />
                <p-dropdown  class='w-100' appendTo="body" [options]="getMonths" [autoDisplayFirst]="true"
                    placeholder="Month" optionLabel="name"  optionValue="code" (onChange)="onChangeDuration($event,'month')">
                </p-dropdown>
            </div>
        </div>
    </div>
    <div class="col-12">
        <p-table [value]="getPayslipDetails" [resizableColumns]="true" styleClass="p-datatable-gridlines">
            <ng-template pTemplate="header">
                <tr>
                    <th>Month</th>
                    <th>Payment Date</th>
                    <th>Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-loadData let-rowIndex="rowIndex">
                <tr>
                    <td>{{loadData?.month}}</td>
                    <td>{{loadData?.payDateStr}}</td>
                    <td>
                        <div class="row">
                            <div><i class="fa fa-eye pr-2 icn" title="View" (click)="view()"></i> </div>
                            <div> <i class="fa fa-download icn" title="Download" (click)="download()"></i>
                            </div>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-loadData>
                <tr>
                    <td [attr.colspan]="3" class="text-center">
                        No records found
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>